import { loadStripe } from '@stripe/stripe-js';

// Singleton Stripe loader — required for Elements
let stripePromise = null;

export const getStripe = () => {
  if (!stripePromise) {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY missing in .env');
      return null;
    }
    stripePromise = loadStripe(key);
  }
  return stripePromise;
};
